(() => {
  const normalise = value => value.toLowerCase().normalize('NFKD').replace(/[^a-z0-9]/g, '');
  function initialise(scope) {
    scope.querySelectorAll('[data-dp-finder]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const search = root.querySelector('input[data-search]');
      const maker = root.querySelector('[data-maker-filter]');
      const type = root.querySelector('[data-type-filter]');
      const cards = [...root.querySelectorAll('[data-model-card]')];
      const count = root.querySelector('[data-count]');
      const singular = count.dataset.singular;
      const plural = count.dataset.plural;
      const update = () => {
        const query = normalise(search.value.trim());
        let visible = 0;
        cards.forEach(card => {
          const matches = (!query || normalise(card.dataset.search).includes(query)) &&
            (!maker.value || card.dataset.maker === maker.value) &&
            (!type.value || card.dataset.type === type.value);
          card.hidden = !matches;
          if (matches) visible++;
        });
        count.textContent = (visible === 1 ? singular : plural).replace('[count]', String(visible));
        root.querySelector('[data-empty]').hidden = visible !== 0;
      };
      [search, maker, type].forEach(control => control.addEventListener('input', update));
      [maker, type].forEach(control => control.addEventListener('change', update));
      root.querySelectorAll('[data-reset]').forEach(button => button.addEventListener('click', () => {
        search.value = maker.value = type.value = '';
        update();
        search.focus();
      }));
      root.querySelector('[data-filters]').hidden = false;
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document));
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
